import API_BASE_URL from '../config/api';

const ALLOWED_HOST = new URL(API_BASE_URL).hostname;

const isTrustedUrl = (url) => {
  try {
    const { hostname, protocol } = new URL(url);
    return (protocol === 'https:') &&
      (hostname === ALLOWED_HOST || hostname.endsWith('.amazonaws.com'));
  } catch { return false; }
};

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('vrvToken')}`,
});

const parse = async (res) => {
  const data = await res.json();
  return typeof data.body === 'string' ? JSON.parse(data.body) : data;
};

export const listBooks = async (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  const res = await fetch(`${API_BASE_URL}/vrv-books-list${qs ? '?' + qs : ''}`);
  return parse(res);
};

export const getBook = async (bookId) => {
  const res = await fetch(`${API_BASE_URL}/vrv-books-get?bookId=${bookId}`);
  return parse(res);
};

export const createBook = async (book) => {
  const res = await fetch(`${API_BASE_URL}/vrv-books-create`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(book),
  });
  return parse(res);
};

export const updateBook = async (bookId, updates) => {
  const res = await fetch(`${API_BASE_URL}/vrv-books-update`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify({ bookId, ...updates }),
  });
  return parse(res);
};

export const deleteBook = async (bookId) => {
  const res = await fetch(`${API_BASE_URL}/vrv-books-delete`, {
    method: 'DELETE',
    headers: authHeaders(),
    body: JSON.stringify({ bookId }),
  });
  return parse(res);
};

export const getUploadUrl = async (fileName, fileType) => {
  const res = await fetch(`${API_BASE_URL}/vrv-books-upload-url`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ fileName, fileType }),
  });
  return parse(res);
};

export const uploadImageToS3 = async (uploadUrl, file) => {
  if (!isTrustedUrl(uploadUrl)) throw new Error('Untrusted upload URL');
  const res = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });
  if (!res.ok) throw new Error('S3 upload failed');
};
